import { render } from "./PaginaContacto.vue?vue&type=template&id=b0d18d00"
import script from "./PaginaContacto.vue?vue&type=script&lang=js"
export * from "./PaginaContacto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__